import { ROLE_TYPE } from './types';
import useRequireRole from './useRequireRole';
import useRole from './useRole';

export const useIsPublisher = () => useRole(ROLE_TYPE.PUBLISHER);
export const useRequirePublisher = () => useRequireRole(ROLE_TYPE.PUBLISHER);
